import { takeLatest, call, put } from "redux-saga/effects";
import {
  SUBMIT_COMPETITOR_PROFILE_REQUEST,
  submitCompetitorProfileSuccess,
  submitCompetitorProfileFailure,
} from "../actions/competitorProfileActions";
import { fetchCompetitorProfile } from "../../../services/accIqService";

// Worker Saga
function* handleCompetitorProfileSubmission(action) {
  try {
    const response = yield call(fetchCompetitorProfile, action.payload);
    yield put(submitCompetitorProfileSuccess(response));
  } catch (error) {
    yield put(
      submitCompetitorProfileFailure(error?.message || "Something went wrong")
    );
  }
}

// Watcher Saga
export function* watchCompetitorProfileSubmission() {
  yield takeLatest(
    SUBMIT_COMPETITOR_PROFILE_REQUEST,
    handleCompetitorProfileSubmission
  );
}
